export default {
  'serialRedemption.title': 'แลกรหัส',
  'serialRedemption.heading': 'กรอกหมายเลขซีเรียล',
  'serialRedemption.instruction': 'เมื่อกรอกแล้ว ให้กดปุ่ม “รับรางวัล”',
  'serialRedemption.codeLabel': 'รหัส',
  'serialRedemption.codePlaceholder': 'กรอกหมายเลขซีเรียล',
  'serialRedemption.codeHint': 'กรอกตัวอักษรหรือตัวเลข 1 ถึง 32 ตัว',
  'serialRedemption.submit': 'รับรางวัล',
  'serialRedemption.successReward': 'แลกรางวัลสำเร็จ คุณได้รับ “{name}”',
  'serialRedemption.successPoint': 'แลกรางวัลสำเร็จ เพิ่ม {quantity} คะแนนแล้ว',
  'serialRedemption.successGift':
    'แลกรางวัลสำเร็จ ชุดของขวัญถูกเพิ่มไปยังกระเป๋าคูปองแล้ว',
  'serialRedemption.goToCouponWallet': 'ไปที่กระเป๋าคูปอง',
  'serialRedemption.goToPointCard': 'ไปที่หน้าคะแนน',
  'serialRedemption.goToPointRecords': 'ไปที่ประวัติคะแนน',
  'serialRedemption.confirm': 'ตกลง',
  'serialRedemption.error.SR-001':
    'ไม่มีซีเรียลนี้ โปรดตรวจสอบแล้วลองป้อนใหม่',
  'serialRedemption.error.SR-002': 'รหัสนี้ถูกรับไปแล้วและไม่สามารถใช้ซ้ำได้',
  'serialRedemption.error.alreadyRedeemedByMember':
    'คุณแลกรหัสนี้แล้ว รางวัลถูกส่งไปยังบัญชีของคุณแล้ว',
  'serialRedemption.error.SR-003': 'รหัสนี้หมดอายุแล้วและไม่สามารถรับรางวัลได้',
  'serialRedemption.error.SR-004':
    'ไม่สามารถแลกสิทธิพิเศษนี้ได้ในขณะนี้ กรุณาติดต่อฝ่ายบริการลูกค้า',
  'serialRedemption.error.SR-005':
    'คุณแลกรางวัลถึงขีดจำกัดของแคมเปญนี้แล้ว',
  'serialRedemption.error.SR-006': 'มอบรางวัลไม่สำเร็จ โปรดลองอีกครั้งภายหลัง',
  'serialRedemption.error.SR-007':
    'สิทธิพิเศษนี้ยังไม่เริ่ม โปรดรับรางวัลหลังจากกิจกรรมเริ่มแล้ว',
  'serialRedemption.error.SR-008': 'กรุณาเข้าสู่ระบบก่อนรับรางวัล',
  'serialRedemption.error.SR-010':
    'ไม่สามารถแลกสิทธิพิเศษนี้ได้ในขณะนี้ กรุณาติดต่อฝ่ายบริการลูกค้า',
  'serialRedemption.error.SR-011':
    'ไม่สามารถแลกสิทธิพิเศษนี้ได้ในขณะนี้ กรุณาติดต่อฝ่ายบริการลูกค้า',
  'serialRedemption.error.rateLimited': 'ลองหลายครั้งเกินไป โปรดลองอีกครั้งภายหลัง',
  'serialRedemption.error.unknown': 'ระบบไม่พร้อมใช้งาน โปรดลองอีกครั้งภายหลัง',
} as Record<string, string>;
